import makeover from '../views/artistry/makeover'

export default [
  {
    path : '/artistry/makeover',
    name :'artistry_makeover',
    component : makeover
  },
]


// WEBPACK FOOTER //
// ./src/router/artistry.js